import { render, staticRenderFns } from "./invitelist.vue?vue&type=template&id=15cb7c22&scoped=true&"
import script from "./invitelist.vue?vue&type=script&lang=js&"
export * from "./invitelist.vue?vue&type=script&lang=js&"
import style0 from "./invitelist.vue?vue&type=style&index=0&id=15cb7c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb7c22",
  null
  
)

export default component.exports